module.exports = __webpack_public_path__ + "static/media/footerLogo.0bb98803.svg";